import { render } from "./MessageMain.vue?vue&type=template&id=38f0c50e&scoped=true"
import script from "./MessageMain.vue?vue&type=script&lang=js"
export * from "./MessageMain.vue?vue&type=script&lang=js"

import "./MessageMain.vue?vue&type=style&index=0&id=38f0c50e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f0c50e"]])

export default __exports__